import Loading from './Loading';
export { Props } from './Loading';
export default Loading;
